import { useEffect, useMemo, useState } from "react";
import api from "@/lib/api";

export default function SlotPicker({ slug, blockId, value, onChange, accent, reloadKey, labels = {} }) {
  const [data, setData] = useState(null);
  const [day, setDay] = useState(null);
  const [failed, setFailed] = useState(false);
  const [retry, setRetry] = useState(0);
  useEffect(() => {
    setData(null); setFailed(false);
    api.get(`/public/forms/${slug}/slots`, { params: { block_id: blockId }, timeout: 30000 })
      .then((r) => setData(r.data)).catch(() => { setFailed(true); setData({ slots: [] }); });
  }, [slug, blockId, reloadKey, retry]);

  const days = useMemo(() => {
    const m = new Map();
    (data?.slots || []).forEach((s) => { if (!s?.date || !s?.start) return; if (!m.has(s.date)) m.set(s.date, { label: s.date_label || s.date, slots: [] }); m.get(s.date).slots.push(s); });
    return [...m.entries()];
  }, [data]);

  useEffect(() => {
    if (!days.length) return;
    const chosen = days.find(([, d]) => d.slots.some((s) => s.start === value));
    setDay(chosen ? chosen[0] : days[0][0]);
  }, [days, value]);

  if (!data) return <div className="text-sm opacity-60" data-testid="slots-loading">{labels.slots_loading || "Finding open times…"}</div>;
  if (failed) return <div className="text-sm" data-testid="slots-error">Couldn't load times. <button className="underline" onClick={() => setRetry((r) => r + 1)} data-testid="slots-retry">Retry</button></div>;
  if (!days.length) return <div className="text-sm opacity-70" data-testid="slots-empty">{labels.slots_empty || "No open times in the next few days. We'll reach out to schedule."}</div>;
  const cur = days.find(([d]) => d === day)?.[1];

  return (
    <div data-testid="slot-picker">
      <div className="flex gap-2 overflow-x-auto pb-2 -mx-1 px-1">
        {days.map(([d, info]) => {
          const [wd, dd, mon] = String(info.label).split(" ");
          const on = d === day;
          return (
            <button key={d} type="button" onClick={() => setDay(d)} data-testid={`slot-day-${d}`}
              className="tf-choice shrink-0 w-16 py-2 rounded-md text-center transition-colors"
              style={on ? { borderColor: accent, background: `${accent}1a` } : undefined}>
              <div className="text-[10px] uppercase tracking-wider opacity-60">{wd}</div>
              <div className="text-lg font-medium leading-tight">{dd}</div>
              <div className="text-[10px] opacity-50">{mon}</div>
            </button>
          );
        })}
      </div>
      <div className="grid grid-cols-3 sm:grid-cols-4 gap-2 mt-3">
        {(cur?.slots || []).map((s) => {
          const on = s.start === value;
          return (
            <button key={s.start} type="button" onClick={() => onChange(s.start)} data-testid={`slot-${s.start}`}
              className="tf-choice py-2.5 rounded-md text-sm transition-colors"
              style={on ? { borderColor: accent, background: accent, color: "#000" } : undefined}>
              {s.time_label}
            </button>
          );
        })}
      </div>
      <div className="text-[11px] opacity-50 mt-3">{labels.timezone_note || "Times shown in IST"} · {data.duration_min} min Google Meet</div>
    </div>
  );
}
